module.exports = __webpack_public_path__ + "img/noTagQues.995c1e85.svg";